import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function C() {
    const { useLang, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('wave2portableairconditioner');
    const NA_SITES = ['us', 'ca'];
    const [source, setSource] = useState('');
    const cards = [
        {
            source: 'https://www.youtube.com/embed/MgJ3-Wr-q2I?si=dWfK6NjrxyWDYIC7',
            text: t('detail.sectionC_card1_text'),
            author: t('detail.sectionC_card1_author'),
            view: t('detail.sectionC_card1_view'),
        },
        {
            source: 'https://www.youtube.com/embed/EKJ-ivwfbMw?si=M0pMUgrLpUiFOrPg',
            text: t('detail.sectionC_card2_text'),
            author: t('detail.sectionC_card2_author'),
            view: t('detail.sectionC_card2_view'),
        },
        {
            source: 'https://www.youtube.com/embed/yZavrHJsBAw?si=bi9BgXx-8VyvvoM-',
            text: t('detail.sectionC_card3_text'),
            author: t('detail.sectionC_card3_author'),
            view: t('detail.sectionC_card3_view'),
        },
    ];

    const handleClick = (card, key) => {
        setSource(card?.source);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: card?.text,
            position: `Product Detail_${key + 2}`,
        });
    };

    return (
        <div className={`wave2-detail-C ${css.wave2DetailC}`}>
            {!NA_SITES.includes(locale) && (
                <div className="viewport-wrapper">
                    <p className="title">
                        <span>{t('teaser.sectionE_title')}</span>
                    </p>
                    <p className="desc">
                        <span>{t('teaser.sectionE_desc')}</span>
                    </p>
                </div>
            )}
            {NA_SITES.includes(locale) && (
                <div className="na-box">
                    <p className="title">{t('detail.sectionC_title')}</p>
                    <Swiper
                        className="swiper-box"
                        spaceBetween={20}
                        // centeredSlides={true}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        navigation={false}
                    >
                        {cards?.map((card: any, k: number) => (
                            <SwiperSlide className="swiper-item" key={k}>
                                <div className="card-img" onClick={() => handleClick(card, k)}>
                                    <NextImage src={require(`@publicLocal/wave2/detail/c_${k + 1}.jpg`)} alt={card?.author} aria-label={card?.author} />
                                    <svg className="play-icon" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                                        <g clipPath="url(#clip0_341_978)">
                                            <rect x="21.5996" y="20.4" width="19.5" height="19.5" fill="white" />
                                            <path
                                                d="M25 40V22.5L40 31.28L25 40ZM59.4 19.1675C59.4 19.1675 58.8125 15.005 57.015 13.17C54.7325 10.7625 52.175 10.7525 51.0025 10.6125C42.6075 10 30.0125 10 30.0125 10H29.9875C29.9875 10 17.3925 10 8.9975 10.6125C7.8225 10.7525 5.2675 10.7625 2.9825 13.17C1.185 15.005 0.6 19.17 0.6 19.17C0.6 19.17 0 24.055 0 28.9425V33.53C0 38.42 0.6 43.31 0.6 43.31C0.6 43.31 1.185 47.4725 2.9825 49.3075C5.2675 51.715 8.265 51.6375 9.6 51.89C14.4 52.3575 30 52.5 30 52.5C30 52.5 42.6075 52.48 51.0025 51.87C52.1775 51.7275 54.7325 51.7175 57.015 49.31C58.815 47.475 59.4 43.31 59.4 43.31C59.4 43.31 60 38.4225 60 33.5325V28.9475C60 24.0575 59.4 19.1675 59.4 19.1675Z"
                                                fill="#FF0000"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_341_978">
                                                <rect width="60" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className="card-info">
                                    <p className="card-text">{card?.text}</p>
                                </div>
                                <div className="author-box">
                                    <div className="author-img">
                                        <NextImage
                                            src={require(`@publicLocal/wave2/detail/c_${k + 1}_author.jpg`)}
                                            alt={card?.author}
                                            aria-label={card?.author}
                                        />
                                    </div>
                                    <div className="author-info">
                                        <p className="author-name">{card?.author}</p>
                                        <div className="author-view">
                                            <svg
                                                className="view-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19"
                                                height="19"
                                                viewBox="0 0 19 19"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9.49999 4.74592C5.8822 4.74592 2.81307 6.73034 1.67065 9.49592C2.81307 12.2615 5.8822 14.2459 9.49999 14.2459C13.1178 14.2459 16.1869 12.2615 17.3293 9.49592C16.1869 6.73034 13.1178 4.74592 9.49999 4.74592ZM9.49999 13.0584C7.53245 13.0584 5.93749 11.4635 5.93749 9.49592C5.93749 7.52838 7.53245 5.93342 9.49999 5.93342C11.4675 5.93342 13.0625 7.52838 13.0625 9.49592C13.0625 11.4635 11.4675 13.0584 9.49999 13.0584Z"
                                                    fill="#717171"
                                                />
                                                <path
                                                    d="M7.125 9.49592C7.125 10.1258 7.37522 10.7299 7.82062 11.1753C8.26602 11.6207 8.87011 11.8709 9.5 11.8709C10.1299 11.8709 10.734 11.6207 11.1794 11.1753C11.6248 10.7299 11.875 10.1258 11.875 9.49592C11.875 8.86603 11.6248 8.26194 11.1794 7.81654C10.734 7.37114 10.1299 7.12092 9.5 7.12092C8.87011 7.12092 8.26602 7.37114 7.82062 7.81654C7.37522 8.26194 7.125 8.86603 7.125 9.49592Z"
                                                    fill="#717171"
                                                />
                                            </svg>
                                            <span className="view-text">{card?.view}</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <EFVideoModal
                        visible={Boolean(source)}
                        source={source}
                        onClose={() => setSource('')}
                        playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                    />
                </div>
            )}
        </div>
    );
}
